import React, { useState, useEffect } from 'react';
import "./about1.css";
import App4 from "./about2";
import { Link } from 'react-router-dom';
import Header1 from './header1';


const About = () => {
  const [showApp4, setShowApp4] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;

      // You can adjust the scroll threshold as needed
      if (scrollPosition > 500) {
        setShowApp4(true);
      } else {
        setShowApp4(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <div className='header1'>
        <Header1 />
      </div>
      


      <div className="frame-parenta">

        <div className="vector-parenta">
        <a href='/'>
        <p className='titlename3'>VREON TECH INDIA PVT LTD</p>
        </a>
          <div className="navbara" >
            <div className="frame-itema" />
            <b className="about2a">
              <p className="about3a"><Link to="/about">ABOUT</Link></p></b>
            <b className="home2a"><Link to="/">HOME</Link></b>

            <b className="portfolio2a">
              <p className="about3a"><Link to="/portfolio">PORTFOLIO</Link></p>
            </b>
            <b className="contact1a"><Link to="/contact">CONTACT</Link></b>
            <a href='/'>
            <img className="logo-1-icon1a" alt="" src="/logo.png" />
            </a>
            <b className="our-productsa">
              <p className="about3a"><Link to="/products">PRODUCTS</Link></p>
            </b>
            <b className="service1a"><Link to="/service">SERVICES</Link></b>
          </div>
        </div>
        <img className="aboutimage-1-icona" alt="" src="/aboutimage1111.png" />
        <div className="who">
          <span>Who</span>
          <b>{` `}</b>
        </div>
        <b className="are-we">are we</b>
        <div className="tech-is-an-container">
          <p className="tech-is-an">{/*<b className="vreon">VREON</b>*/}
            Vreon Tech is an AR/VR-XR technological solutions
            developmental organisation based in
            Chennai, India. We devise solutions across
            industries, education and edutainment segments
            with global standards that unlock the world of
            endless possibilities . </p>
        </div>
        <div className="customized-solutions-enable-container">
          <p className="tech-is-an">Our customized solutions enable clients to transcend to the
            Metaverse and aid in engaging
            their business through Web 3.0 platforms. With
            skilled developers, domain experts, and in- house
            creative artists we ensure a well- rounded and
            expert approach to every project. Join hands with
            us for an exciting journey into the world of digital
            innovation that gives you a competitive edge .</p>
        </div>
        {/* <b className="our"> Our</b> */}

      </div>
    </div>
  );
};
const App3 = () => {
  return (
    <div className="App">
      <About />
      <App4 />
    </div>
  );
};

export default App3;
